import { ArrowLeft, AudioLines } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useAgentCopy } from '../lib/agentCopy.js';
import { useQuery } from '@tanstack/react-query';
import { agentApi } from '../lib/agent.js';
import { useAuthenticated } from '../lib/session.js';

export function AgentProfileLink() {
  const c = useAgentCopy();
  const session = useAuthenticated();
  const capabilities = useQuery({ queryKey: ['agent', 'capabilities', session.user.id, session.business.id], queryFn: agentApi.capabilities, retry: false, staleTime: 60000 });
  if (!capabilities.data?.enabled) return null;
  return <Link to="/agent" className="group flex items-center gap-4 rounded-2xl border border-primary/20 bg-primary/5 p-4 transition-colors hover:bg-primary/10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring">
    <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-primary/10 text-primary"><AudioLines size={24} aria-hidden="true"/></span>
    <span className="min-w-0 flex-1"><span className="block text-base font-semibold">{c('profileAgent')}</span><span className="mt-1 block text-sm leading-6 text-muted-foreground">{c('profileAgentBody')}</span><span className="mt-2 inline-flex items-center gap-2 text-sm font-medium text-primary">{c('profileAgentLink')}<ArrowLeft size={16} className="ltr:rotate-180" aria-hidden="true"/></span></span>
  </Link>;
}
